<ng-container *ngIf="groupsListPartial === 'no results'">
  <div class="groups-panel d-md-flex flex-md-column">
    <div class="overflow-auto">
      <div class="no-results">
        <h3 class="no-results__text">No matching errors to display</h3>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="groupsListPartial === 'all resolved'">
  <div class="groups-panel d-md-flex flex-md-column">
    <div class="flex-shrink-0">
      <ab-group-poller
        [groups]="groups"
        [pageParams]="pageParams"
        (update)="reloadPage($event).subscribe()"
      ></ab-group-poller>
    </div>
    <div class="overflow-auto all-resolved">
      <div
        class="all-resolved__icon"
        title="You've reached Airbrake Zero!"
      ></div>
      <h3>All your errors are resolved!</h3>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="groupsListPartial === 'results'">
  <div class="groups-panel d-md-flex flex-md-column">
    <div class="flex-shrink-0">
      <div class="groups-multi-select">
        <div class="groups-multi-select__checkbox ab-checkbox float-left">
          <input
            id="selectedGroups"
            type="checkbox"
            [checked]="selectedGroups().length > 0"
            (click)="toggleSelectionForAll()"
          />
          <label class="ab-checkbox__label" for="selectedGroups"></label>
        </div>
        <button
          class="btn"
          *ngIf="selectedGroups()[0]?.resolved === false"
          (click)="resolveSelected()"
          type="button"
        >
          <i class="glyphicon glyphicon-check-circle"></i>
          Resolve {{ selectedGroups().length }}
        </button>
        <span
          class="dropdown"
          ngbDropdown="ngbDropdown"
          *ngIf="selectedGroups().length < 1"
        >
          <button
            class="btn"
            ngbDropdownToggle="ngbDropdownToggle"
            type="button"
          >
            <span class="glyphicon glyphicon-sort-amount-desc"></span>
          </button>
          <ul
            class="dropdown-menu--reduced-padding"
            ngbDropdownMenu="ngbDropdownMenu"
          >
            <li *ngFor="let sortOption of sortOptions; trackBy: trackByIndex">
              <a
                (click)="updateSort(sortOption)"
                ngbDropdownItem="ngbDropdownItem"
              >
                <i
                  class="list-icon glyphicon"
                  [ngClass]="{
                    'glyphicon-check': filters.order === sortOption.value
                  }"
                ></i>
                {{ sortOption.label }}
              </a>
            </li>
          </ul>
        </span>
        <button
          class="btn"
          *ngIf="selectedGroups()[0]?.resolved === true"
          (click)="unresolveSelected()"
          type="button"
        >
          <i class="glyphicon glyphicon-exclamation-triangle"></i>
          Unresolve {{ selectedGroups().length }}
        </button>
        <div class="groups-multi-select__paginate float-right">
          <div class="groups-multi-select__counter">
            <a
              class="groups-multi-select__refresh glyphicon"
              title="Refresh"
              [ngClass]="{
                'spin-me': loading,
                'glyphicon-bug': !isHovered,
                'glyphicon-refresh': isHovered
              }"
              (mouseenter)="isHovered = true"
              (mouseleave)="isHovered = false"
              (click)="reloadPage().subscribe()"
            >
            </a
            >{{ currentPageStart() }}-{{ currentPageEnd() }} of {{ totalItems }}
          </div>
          <div class="btn-group">
            <button
              class="btn"
              (click)="loadPrevPage()"
              [disabled]="!hasPrevPage()"
              type="button"
            >
              <i class="glyphicon glyphicon-angle-left"></i>
            </button>
            <button
              class="btn"
              (click)="loadNextPage()"
              [disabled]="!hasNextPage()"
              type="button"
            >
              <i class="glyphicon glyphicon-angle-right"></i>
            </button>
          </div>
        </div>
      </div>
      <ab-group-poller
        [groups]="groups"
        [pageParams]="pageParams"
        (update)="reloadPage($event).subscribe()"
      ></ab-group-poller>
    </div>
    <div class="overflow-auto">
      <ul class="groups" tabindex="0">
        <li
          class="group"
          *ngFor="let group of groups; index as $index; trackBy: trackById"
          [ngClass]="{
            'group-resolved': group.resolved,
            'group-selected': group.selected,
            'group-new': group.isNew,
            'group-active': $index === activeGroupIndex
          }"
          [abScrollMe]="$index === activeGroupIndex"
          [@groupAnimation]=""
        >
          <div class="group-selector ab-checkbox float-left">
            <input
              id="groupSelector{{ group.id }}"
              type="checkbox"
              [(ngModel)]="group.selected"
              (click)="stopPropagation($event)"
            />
            <label
              class="ab-checkbox__label"
              for="groupSelector{{ group.id }}"
            ></label>
          </div>
          <a
            class="group-block"
            uiSref="groups-show"
            [uiParams]="groupParams(group.id)"
            (click)="activateGroup($index, $event)"
          >
            <div class="float-left occurrences">
              <ab-env-label
                [env]="group.context.environment"
                [truncate]="$index !== activeGroupIndex"
              ></ab-env-label>
              <span class="badge badge--default badge--small">
                <i
                  class="glyphicon glyphicon-bug"
                  [ngClass]="{ 'spin-me': group.loading }"
                ></i>
                <span *ngIf="group.noticeFilterCount">
                  {{ group.noticeFilterCount | numberToHuman }} of
                </span>
                <span>
                  {{
                    group.noticeCount - (group.newNoticeCount || 0)
                      | numberToHuman
                  }}
                </span>
              </span>
              <span
                class="new-notice-count badge badge--small"
                *ngIf="group.newNoticeCount"
              >
                +{{ group.newNoticeCount }}
              </span>
              <span
                class="badge badge--default badge--small"
                *ngIf="group.commentCount > 0"
              >
                <i class="glyphicon glyphicon-ab-comment"></i>
                {{ group.commentCount }}
              </span>
              <span
                class="badge badge--default badge--small"
                *ngIf="group.muted"
              >
                <i class="glyphicon glyphicon-bell-slash-o"></i>
              </span>
              <span
                class="badge badge--default badge--small"
                *ngIf="group.context.severity"
              >
                {{ group.context.severity }}
              </span>
              <ng-container *ngIf="group.issueIndicators?.length > 0">
                <span
                  *ngFor="
                    let issueIndicator of group.issueIndicators;
                    trackBy: trackByIndex
                  "
                >
                  <span
                    class="badge badge--default badge--small badge--icon"
                    (click)="openUrl(issueIndicator.url)"
                    ngbTooltip="{{ issueIndicator.tooltipText }}"
                    container="body"
                  >
                    <i
                      class="glyphicon glyphicon-ab-integrations-{{
                        issueIndicator.serviceName
                      }}"
                    ></i>
                  </span>
                </span>
              </ng-container>
            </div>
            <ab-bar-chart
              class="float-left sparkline-barchart"
              [config]="group.occurrencesChart"
            ></ab-bar-chart>
            <div
              class="float-right minor-text"
              title="Last occurrence at {{
                group.lastNoticeAt | date: 'MMM dd, y HH:mm:ss Z'
              }}"
            >
              <ab-time-ago [time]="group.lastNoticeAt"></ab-time-ago>
            </div>
            <div class="group-body">
              <span class="ab-type" *ngIf="group.errors[0].type"
                >{{ group.errors[0].type }}:&nbsp;</span
              ><span class="ab-error-message">{{
                group.errors[0] | errorMessageWithoutType
              }}</span>
            </div></a
          >
          <ab-onboarding-callout
            *ngIf="group.id === aggregationsCalloutGroupId"
            [className]="'ShowAggregations'"
            [project]="project"
            [group]="group"
          ></ab-onboarding-callout>
        </li>
      </ul>
    </div>
  </div>
</ng-container>
